import generateBootFunc from '../../generate-boot';
import MediaLibrary from './Components/MediaLibrary.vue';
import MediaLibraryImageCrop from './Components/MediaLibraryImageCrop.vue';

const bootMediaLibrary = generateBootFunc(MediaLibrary, 'media-library');
const bootMediaLibraryImageCrop = generateBootFunc(MediaLibraryImageCrop, 'media-library-image-crop');

export {
    bootMediaLibrary,
    bootMediaLibraryImageCrop
};